import React from "react";
import PropTypes from "prop-types";
import Utility from "app/horoscope/utility/utility";

const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '12px',
    background: '#fff',
    marginTop: '24px',
};

const thTdStyle = {
    border: '1px solid #ccc',
    padding: '0px 2px',
    textAlign: 'center',
};


const tdTdStyle = {
    border: '1px solid #ccc',
    padding: '0px 2px',
    textAlign: 'left',
};

export default function PlanetDataTable({ planetData }) {
    return (
        <table style={tableStyle}>
            <thead>
                <tr>
                    <th style={thTdStyle}></th>
                    <th style={thTdStyle}>ග්‍රහයා</th>
                    <th style={thTdStyle}>ස්ථුටය</th>
                    <th style={thTdStyle}>රාශිය</th>
                    <th style={thTdStyle}>නැකත</th>
                    <th style={thTdStyle}>රාශි බල</th>
                    <th style={thTdStyle}>වක්‍ර</th>
                    <th style={thTdStyle}>අවස්තාව</th>
                </tr>
            </thead>
            <tbody>
                {planetData.map((row, idx) => (
                    <tr key={idx}>
                        <td style={tdTdStyle}><p dangerouslySetInnerHTML={{ __html: `${Utility.getPlanetSymbol(row.planet)}` }} /></td>
                        <td style={tdTdStyle}>{row.planet}</td>
                        <td style={tdTdStyle}>{row.place}</td>
                        <td style={tdTdStyle}>{row.rashiya}</td>
                        <td style={tdTdStyle}>{row.nekatha}</td>
                        <td style={tdTdStyle}>{row.ucha}</td>
                        <td style={tdTdStyle}>{row.wakra}</td>
                        <td style={tdTdStyle}>{row.awasthawa}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );

    PlanetDataTable.propTypes = {
        planetData: PropTypes.object.isRequired,
    };
}
